import styles from './index.less';
import * as React from 'react';
import aos from '@src/utils/aos';
import MatchBracket from './match-bracket';
import videoImage from '../../images/video.jpg';

const DEFAULT_LIVE_ITEMS = [{ imageUrl: videoImage, videoUrl: '' }, { imageUrl: videoImage, videoUrl: '' }, { imageUrl: videoImage, videoUrl: '' }];
const SUPPORT_SECTION_VISIBLE = false;
const SCHEDULE_TIMELINE_VISIBLE = false;
const SCHEDULE_ITEMS = [
  { id: 1, lines: ['8月4日至', '8月31日22:30'], className: styles.scheduleWide },
  { id: 2, lines: ['9月1日'], className: styles.scheduleWideSingle },
  { id: 3, lines: ['9月2日', '14:00'] },
  { id: 4, lines: ['9月8日', '20:00'] },
  { id: 5, lines: ['9月9日', '20:00'] },
  { id: 6, lines: ['9月11日', '20:00'] },
  { id: 7, lines: ['9月12日', '14:00'] },
  { id: 8, lines: ['9月15日', '20:00'], className: styles.scheduleMedium },
  { id: 9, lines: ['9月16日', '20:00'], className: styles.scheduleMedium },
  { id: 10, lines: ['9月18日', '20:00'], className: styles.scheduleMedium }
];

const classNames = (...names) => names.filter(Boolean).join(' ');
const getVideoId = videoUrl => {
  const matchedVideoId = videoUrl.match(/\d+/);
  return matchedVideoId ? matchedVideoId[0] : '';
};

export const openVideo = videoUrl => {
  if (!videoUrl || typeof window === 'undefined' || typeof window.open !== 'function') {
    return false;
  }

  try {
    const videoWindow = window.open(videoUrl, '_blank', 'noopener,noreferrer');
    if (videoWindow) {
      videoWindow.opener = null;
    }
    return !!videoWindow;
  } catch (error) {
    return false;
  }
};

const EventOverview = ({ content, matchBracketStore }) => {
  const configuredLiveItems = Array.isArray(content.liveItems) ? content.liveItems : [];
  const liveItems = DEFAULT_LIVE_ITEMS.map((defaultItem, index) => configuredLiveItems[index] || defaultItem);

  return (
    <div className={styles.root}>
      <section className={classNames(styles.contentSession, styles.scheduleSection)} aria-labelledby="event-overview-schedule-title">
        <div className={styles.content}>
          <h2 className={styles.title} id="event-overview-schedule-title">
            比赛赛程
          </h2>
          {content.scheduleImageUrl ? (
            <img
              className={styles.scheduleImage}
              src={content.scheduleImageUrl}
              alt="比赛赛程"
              data-aos-duration="600"
              data-aos-once="true"
              {...aos.FADE_RIGHT()}
            />
          ) : null}
          {SCHEDULE_TIMELINE_VISIBLE ? (
            <div className={styles.schedule} data-aos-duration="600" data-aos-once="true" {...aos.FADE_RIGHT()}>
              {SCHEDULE_ITEMS.map(item => (
                <div className={classNames(styles.scheduleItem, styles[`scheduleItem${item.id}`], item.className)} key={item.id}>
                  <p>{item.lines[0]}</p>
                  {item.lines[1] ? <span>{item.lines[1]}</span> : null}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </section>

      <section className={classNames(styles.contentSession, styles.matchSection)} aria-labelledby="event-overview-match-title">
        <div className={styles.content}>
          <h2
            className={classNames(styles.title, styles.matchTitle)}
            id="event-overview-match-title"
            data-aos-duration="600"
            data-aos-once="true"
            {...aos.FADE_DOWN()}
          >
            对阵详情
          </h2>
          <div data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
            <MatchBracket matchConfigUrl={content.matchConfigUrl} store={matchBracketStore} />
          </div>
        </div>
      </section>

      {SUPPORT_SECTION_VISIBLE ? (
        <section className={classNames(styles.contentSession, styles.supportSection)} aria-labelledby="event-overview-support-title">
          <div className={styles.content}>
            <h2
              className={classNames(styles.title, styles.supportTitle)}
              id="event-overview-support-title"
              data-aos-duration="600"
              data-aos-once="true"
              {...aos.FADE_DOWN()}
            >
              助威竞猜
            </h2>
            <div className={styles.ruleBox} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
              <p>
                <b>活动时间：</b>
                <span>9月2日-9月18日23:00</span>
              </p>
              <p>
                <b>领奖截止时间：</b>9月23日维护开始前
              </p>
              <p>活动内容：</p>
              <p>1、天下第一帮正赛开启后，将会同步开启“擂鼓助威”活动，各位大侠可以通过右上角活动图标前往参与。</p>
              <p>
                2、大侠可为自己喜爱的32强帮会进行“助威”加油！每次助威，需要消耗<span>【助威锣鼓】</span>道具，该道具可通过如下方式获取：
              </p>
              <table className={styles.prizeTable}>
                <thead>
                  <tr>
                    <th>“助威锣鼓”获取方式</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>（1）每日达成45活跃度可获得2个助威锣鼓，达到75活跃还将获得3个助威锣鼓。每日通过活跃度共可获得5个助威锣鼓。</td>
                  </tr>
                  <tr>
                    <td>（2）可于活动界面进行购买：100金币可购买1个助威锣鼓。</td>
                  </tr>
                  <tr>
                    <td>（3）每日将会上架限购超值的锣鼓礼包，届时有意向的大侠可以前往选购哦！</td>
                  </tr>
                </tbody>
              </table>
              <p>
                3、本次活动共设有帮会人气榜、大侠助威榜两个榜单，分别展示参赛帮会的人气值排行以及各位大侠的助威次数排行。本次排行榜为全区全服排行。人气榜前三的帮会成员可获得
                <span>稀有称号奖励</span>！
              </p>
              <p>
                4、被助威的参赛帮会，将会获得对应的人气值。助威越多，人气值最高。活动期间，排行榜每5分钟刷新一次帮会的人气值。
                <br />· 每个帮会都将会记录并展示本帮收到助威支持数排名前六的玩家，以及展示这六名玩家对本帮会的助威数。
                <br />· 每名玩家都将会记录并展示自己助威支持排名前六的帮会，以及对这些帮会分别投入的助威支持数。
              </p>
              <p>
                5、玩家每使用1个助威锣鼓可获得100个巅峰币，且助威的对应帮会可获得1点人气值。巅峰币可在<span>助威活动商店</span>中兑换丰厚的奖励。
              </p>
              <p>
                6、请各位大侠注意，“助威锣鼓”以及“巅峰币”道具不支持存放以及后续的活动使用，因此还请大家记得在活动时间内抓紧使用哦！
                <br />
                活动奖励：参赛帮会人气榜奖励、大侠助威榜奖励以及巅峰币商店奖励请各位大侠
                <a href="https://jxsj.xoyo.com/show-3415-11770-1.html" target="_blank" rel="noopener noreferrer" title="点击前往">
                  点击前往
                </a>
                奖励新闻进行了解。
              </p>
              <p className={styles.tips}>
                温馨提示：本次活动内未标注时效的奖励物品均在游戏运营期内长期有效，未特殊注明的奖励均为绑定，活动内容与奖励请以游戏内实际为准。
              </p>
            </div>
          </div>
        </section>
      ) : null}

      <section className={classNames(styles.contentSession, styles.videoSection)} aria-labelledby="event-overview-video-title">
        <div className={styles.content}>
          <h2
            className={classNames(styles.title, styles.videoTitle)}
            id="event-overview-video-title"
            data-aos-duration="600"
            data-aos-once="true"
            {...aos.FADE_DOWN()}
          >
            直播回顾
          </h2>
          <div className={styles.videoList} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
            {liveItems.map(
              ({ imageUrl, videoUrl }, index) =>
                videoUrl ? (
                  <button
                    type="button"
                    className={classNames(styles.videoCard, styles.videoCardButton)}
                    aria-label={`打开直播回顾 ${index + 1}`}
                    data-video-id={getVideoId(videoUrl)}
                    key={`${videoUrl}-${index}`}
                    onClick={() => openVideo(videoUrl)}
                  >
                    <img src={imageUrl} alt={`天下第一帮直播回顾 ${index + 1}`} />
                    <span className={styles.playIcon} aria-hidden="true" />
                  </button>
                ) : (
                  <div className={styles.videoCard} key={`${imageUrl}-${index}`}>
                    <img src={imageUrl} alt="天下第一帮直播回顾" />
                  </div>
                )
            )}
          </div>
        </div>
      </section>

      <section className={classNames(styles.contentSession, styles.copyrightSession)} aria-label="活动最终解释权说明">
        <div className={styles.content}>
          <p className={styles.copyright}>*本次活动最终解释权归金山西山居所有！</p>
        </div>
      </section>
    </div>
  );
};

export default EventOverview;
